import styled from 'styled-components';


export const Coluna = styled.p`
  flex: 1;
  text-align: center;
`;
